// extracted by mini-css-extract-plugin
export default {"video":"video_video__zJsy8","playBtn":"video_playBtn__Jdz6o","isPlaying":"video_isPlaying__b42Zo"};